/* Galéria: a card opens its drop's photos in a full-screen <dialog>; a photo opens a
   viewer with prev/next, arrow keys and swipe. #anchor links open a drop directly.
   Editor-safe via section load/unload; selecting a photo block in the editor opens it. */
(function () {
  var cards = new WeakMap();

  function mount(card) {
    if (cards.has(card)) return;
    var dlg = card.querySelector('[data-dg-dialog]');
    var opener = card.querySelector('[data-dg-open]');
    if (!dlg || !opener) return;
    var q = function (s) { return dlg.querySelector(s); };
    var view = q('[data-dg-view]'), img = q('[data-dg-img]'), cap = q('[data-dg-cap]'),
        count = q('[data-dg-count]'), prev = q('[data-dg-prev]'), next = q('[data-dg-next]');
    var photos = [].slice.call(dlg.querySelectorAll('[data-dg-photo]'));
    var openLabel = dlg.getAttribute('data-open-label') || '';
    var anchor = card.getAttribute('data-anchor');
    var current = 0, lastPhoto = null, x0 = null, offs = [], seq = 0, cache = {};
    var SIZES = '(max-width: 1600px) 100vw, 1600px';

    q('[data-dg-title]').textContent = card.getAttribute('data-title') || '';
    dlg.setAttribute('aria-label', card.getAttribute('data-title') || '');
    photos.forEach(function (b, i) {
      var what = b.getAttribute('data-caption') || b.getAttribute('data-alt') || '';
      b.setAttribute('aria-label', [openLabel, what].filter(Boolean).join(': ') || String(i + 1));
      b.parentNode.style.setProperty('--i', Math.min(i, 12));
    });
    var single = photos.length < 2;
    prev.hidden = next.hidden = single;

    function on(el, ev, fn) { el.addEventListener(ev, fn); offs.push(function () { el.removeEventListener(ev, fn); }); }
    function setHash(h) { try { history.replaceState(null, '', h ? '#' + h : location.pathname + location.search); } catch (e) {} }

    function openSheet() {
      if (typeof dlg.showModal !== 'function') return;
      if (!dlg.open) { dlg.showModal(); document.documentElement.classList.add('dg-lock'); }
      if (anchor) setHash(anchor);
    }
    /* Full-size image for photo i; the browser picks the right width from srcset. */
    function full(i) {
      i = (i + photos.length) % photos.length;
      if (!cache[i]) {
        var b = photos[i], im = new Image();
        im.decoding = 'async';
        im.sizes = SIZES;
        im.srcset = b.getAttribute('data-srcset') || '';
        im.src = b.getAttribute('data-full');
        cache[i] = im;
      }
      return cache[i];
    }
    function show(i) {
      current = (i + photos.length) % photos.length;
      var b = photos[current], thumb = b.querySelector('img'), hi = full(current), token = ++seq;
      /* Show the already-loaded grid thumbnail at once, then swap in the sharp one. */
      img.removeAttribute('srcset');
      img.src = hi.complete && hi.currentSrc ? hi.currentSrc : (thumb && (thumb.currentSrc || thumb.src)) || hi.src;
      (hi.decode ? hi.decode() : Promise.resolve()).then(function () {
        if (token === seq && !view.hidden) img.src = hi.currentSrc || hi.src;
      }, function () {});
      if (!single) { full(current + 1); full(current - 1); }
      img.alt = b.getAttribute('data-alt') || '';
      cap.textContent = b.getAttribute('data-caption') || '';
      count.textContent = single ? '' : (current + 1) + ' / ' + photos.length;
    }
    function openView(i) { lastPhoto = photos[i]; show(i); view.hidden = false; q('[data-dg-vclose]').focus(); }
    function closeView() { view.hidden = true; img.removeAttribute('src'); if (lastPhoto) lastPhoto.focus(); }

    on(opener, 'click', openSheet);
    on(q('[data-dg-close]'), 'click', function () { dlg.close(); });
    photos.forEach(function (b, i) { on(b, 'click', function () { openView(i); }); });
    on(q('[data-dg-vclose]'), 'click', closeView);
    on(prev, 'click', function () { show(current - 1); });
    on(next, 'click', function () { show(current + 1); });
    on(view, 'click', function (e) { if (e.target === view) closeView(); });
    /* Esc closes the viewer first, then the sheet. */
    on(dlg, 'cancel', function (e) { if (!view.hidden) { e.preventDefault(); closeView(); } });
    on(dlg, 'keydown', function (e) {
      if (view.hidden || single) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });
    on(view, 'pointerdown', function (e) { x0 = e.clientX; });
    on(view, 'pointerup', function (e) {
      if (x0 === null || single) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) show(current + (dx < 0 ? 1 : -1));
    });
    on(dlg, 'close', function () {
      document.documentElement.classList.remove('dg-lock');
      if (!view.hidden) closeView();
      if (anchor && location.hash === '#' + anchor) setHash('');
      opener.focus();
    });

    if (anchor && location.hash === '#' + anchor) openSheet();
    cards.set(card, {
      dlg: dlg,
      destroy: function () { offs.forEach(function (f) { f(); }); if (dlg.open) dlg.close(); }
    });
  }

  function mountAll(scope) { (scope || document).querySelectorAll('[data-dg-card]').forEach(mount); }
  function unmountAll(scope) {
    scope.querySelectorAll('[data-dg-card]').forEach(function (c) {
      var inst = cards.get(c); if (inst) { inst.destroy(); cards.delete(c); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { unmountAll(e.target); });
  /* Theme editor: picking a block inside a closed gallery opens it; leaving closes it. */
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-dg-card]');
    var inst = card && cards.get(card);
    if (inst && inst.dlg.contains(e.target) && !inst.dlg.open) { inst.dlg.showModal(); document.documentElement.classList.add('dg-lock'); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var card = e.target.closest && e.target.closest('[data-dg-card]');
    var inst = card && cards.get(card);
    if (inst && inst.dlg.open) inst.dlg.close();
  });
})();
